/**
 * Trial Ending Soon Reminder Modal
 *
 * Shown on launch when user is in trial with 1-3 days remaining.
 * Renders Practice or Clinician upgrade modal based on signup source
 * or practice trial status.
 */

import { ModalId, SignupSource } from '@heidi/schema/ml-scribe';
import { useReverseTrial } from '../../data';
import { getCommerceBillingUiPorts } from '../settings/billing/billing-ui-ports';
import { PracticeUpgradeModal } from '../settings/billing/components/practice-upgrade-modal';
import { getCommerceTrialsUiPorts } from '../trials-and-upgrades/trials-ui-ports';

export const TrialEndingSoonReminderModal = () => {
  const commerceBillingUiPorts = getCommerceBillingUiPorts();
  const commerceTrialsUiPorts = getCommerceTrialsUiPorts();
  const ClinicianUpgradeModal = commerceBillingUiPorts.ClinicianUpgradeModal;
  const { isOpen: isQueueOpen, handleClose: handleQueueClose } =
    commerceTrialsUiPorts.useQueuedModal(ModalId.TRIAL_ENDING_SOON_REMINDER);
  const { data: signupSource } = commerceBillingUiPorts.useQueryUser(
    (u) => u?.signup_source ?? SignupSource.scribe
  );
  const { isPracticeTrialUser } = useReverseTrial();

  if (!isQueueOpen || commerceBillingUiPorts.isAppleCompliantBuild()) {
    return null;
  }

  if (signupSource === SignupSource.practice || isPracticeTrialUser) {
    return (
      <PracticeUpgradeModal launchOpen={isQueueOpen} onLaunchClose={handleQueueClose} />
    );
  }

  // Evidence signup + default: Clinician (Evidence Plus upgrade retired, GRO-3609)
  return (
    <ClinicianUpgradeModal launchOpen={isQueueOpen} onLaunchClose={handleQueueClose} />
  );
};
